import { DbLoadPositionList } from "../../../data/usecases/load-position-list";
import { LoadPositionList } from "../../../domain/usecases/load-position-list";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbLoadPositionList = (): LoadPositionList => {
  return new DbLoadPositionList(
    makeApiUrl("/position"),
    makeAuthorizeHttpClientDecorator()
  );
};
